<template>
    <table class="admin__table">
        <tr v-for="(post, index) in posts" :key="index">
            <td>{{ post.document_id }}</td>
            <td>{{ post.published ? "Published" : "" }}</td>
            <td>{{ post.product_ids.length }}</td>
            <td>{{ post.youtube_id }}</td>
            <td><router-link :to="`/admin/social_posts/${post.document_id}`">Edit</router-link></td>
        </tr>
    </table>
</template>

<script>
  import SocialPost from '../../../models/SocialPost'

  export default {
    data(){
      return{
        posts: [],
      }
    },
    async mounted(){
      this.posts = await SocialPost.page('created_at')
    },
    methods: {

    }
  }
</script>
